import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/empreendimentos/$empreendimentoId
// Este arquivo serve como layout para rotas filhas dentro de $empreendimentoId (ex: /editar)
// Renderiza o Outlet para rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId',
)({
  component: function EmpreendimentoDetailLayout() {
    return <Outlet />
  },
})

